import { render, staticRenderFns } from "./GuessingPhase.vue?vue&type=template&id=2e03f868&"
import script from "./GuessingPhase.vue?vue&type=script&lang=js&"
export * from "./GuessingPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports